import React from "react";
import { BackgroundImage, TeethLogo, ServiceBottomButton } from "../../Components"
import periodontal_dentistry from "../../assets/Images/periodontal-dentistry-home.jpg"

const PeriodontalDentistry = (props) => {
    const { selectedLanguage } = props

    return (
        <div className="main">
            <BackgroundImage heading={selectedLanguage?.periodontal_dentistry_heading} text={selectedLanguage?.txt_explore_our_services} mainClass='periodontal-dentistry-background' />
            <TeethLogo heading={selectedLanguage?.periodontal_dentistry_heading} />
            <div className="dental-service-main">
                <div className="dental-service-img-div">
                    <img src={periodontal_dentistry} alt="dentalImg" />
                </div>
                <div className="dental-service-text-div">
                    <p>
                        {selectedLanguage?.txt_periodontists_are_the_dental_specialists}
                    </p>
                    <p>{selectedLanguage?.txt_normally_this_minimally_invasive}</p>
                    <p>{selectedLanguage?.txt_the_range_of_treatments}</p>
                    <ul>
                        <li>{selectedLanguage?.txt_scaling_and_root_planning}</li>
                        <li>{selectedLanguage?.txt_asthetic_And_gingivectomy}</li>
                        <li>{selectedLanguage?.txt_esthetic_periodontal_crown}</li>
                    </ul>
                    <h2 className="periodontal-heading">{selectedLanguage?.txt_givngivitis_and_periodontities}</h2>
                    <p>{selectedLanguage?.txt_the_term_periondontal_disease}
                    </p>
                    <p>
                        {selectedLanguage?.txt_gingivitis_is_and_inflammatory_condition}
                    </p>
                    <p>{selectedLanguage?.txt_periondontitis_follows_gingivitis}</p>
                    <p>{selectedLanguage?.txt_oral_reason_for_mouth_odor}</p>
                    <p>{selectedLanguage?.txt_our_periondontits_and_oral_surgeons_share_their_knowledge}</p>
                </div>
            </div>
            <ServiceBottomButton {...props} />
        </div>
    )
}

export default PeriodontalDentistry